import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantLoginLogSharedService,
  Wealthlane_Dtos_ParticipantLoginLog_PptLastLoginInfo,
} from '../../services/wealthlane-identity-services';

interface UseGetLastLoginOptions {
  pollingInterval?: number; // in milliseconds
  enablePolling?: boolean;
  enabled?: boolean;
}

const useGetLastLogin = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  options: UseGetLastLoginOptions = {}
): UseQueryResult<
  //  eslint-disable-next-line camelcase
  Wealthlane_Dtos_ParticipantLoginLog_PptLastLoginInfo | undefined,
  unknown
> => {
  const { pollingInterval = 5000, enablePolling = false, enabled } = options;

  const lastLogin = useQuery(
    ['getLastLogin'],
    async () => {
      return await handleRequest(
        ParticipantLoginLogSharedService.getApiIdentityLoginLogLastParticipant()
      );
    },
    {
      refetchInterval: (data) => {
        // Stop polling if enablePolling is false
        if (!enablePolling) return false;

        // Stop polling if last login value is present
        if (data && data.lastLoginAt) {
          return false;
        }

        // Continue polling with the specified interval
        return pollingInterval;
      },
      refetchIntervalInBackground: false, // Don't poll when tab is not active
      enabled: enabled,
    }
  );

  return lastLogin;
};

export default useGetLastLogin;
